export function escapeHtml(raw) {
  return String(raw || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function humanizeSlug(slug) {
  return String(slug || '')
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function extractFaqJsonLd(html, pageUrl = '') {
  if (typeof window === 'undefined' || !html) return null;
  try {
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    const items = [];
    doc.querySelectorAll('details[data-faq]').forEach((el) => {
      const question = el.querySelector('summary')?.textContent?.trim();
      const answer = el.querySelector('[data-faq-answer]')?.textContent?.trim();
      if (!question || !answer) return;
      items.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: { '@type': 'Answer', text: answer },
      });
    });
    if (!items.length) return null;
    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...(pageUrl ? { url: pageUrl } : {}),
      mainEntity: items,
    };
  } catch {
    return null;
  }
}
